import gql from 'graphql-tag';

export default gql`
    query CheckBolFileExists($input: String) {
        checkBolFileExists(input: $input) {
            fileExists
        }
    }
`;
